<template>
  <div class="container flex" style="margin-bottom: 20px;">
    <left></left>
    <div class="live flex1" style="margin-left: 20px;">
    	<div class="title flex" style="padding: 10px;">
    		<span class="">老师答疑-</span>
    		<span style="color: #4fa7ff;">我的提问</span>
    	</div>
    	<div class="lists" v-for="item,index in list">
    		<div class="listtile flex algin-center" @click="handleDetail(item.answerQuestionsId)">
    			<span class="noread" v-if="item.replyStatus==0"></span>
    			{{item.answerQuestionsTitle}}
    			<span class="flex1"></span>
    			<img src="../assets/img/toright.png"  width="8" height="14" >
    		</div>
    	</div>
    </div>
  </div>
</template>

<script>
  import left from './left.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          data:'',
          list:[]
      }
    },
    methods:{
      getData(){
        this.$axios.get(this.$common.questions_list).then((res)=>{
              if(res.data.code==1){
                  this.list=res.data.data;
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleDetail(id){
        this.$router.push({path:'questiondetail?id='+id})
      }
    },
    created(){
      this.getData();
    }
  }
</script>

<style scoped>
  .live .viewWrap {
  	margin-left: 0;
  }
  .live .lists {
  	text-indent: 0;

  }
  .live .lists .listtile {
  	padding: 0 15px;
  }
  .noread {
  	width: 4px;
  	height: 4px;
  	background-color: red;
  	border-radius: 100%;
  	margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/myteacheranswers.vue